import { useMockApi, mockPost } from "./mockApi";

export const apiFetch = async (url, options = {}) => {
  if (!useMockApi) {
    return fetch(url, options);
  }

  const method = (options.method || "GET").toUpperCase();
  if (method === "POST") {
    const body = options.body ? JSON.parse(options.body) : {};
    const res = await mockPost(url, body);
    return {
      ok: res.status >= 200 && res.status < 300,
      status: res.status,
      json: async () => res.data,
    };
  }

  return {
    ok: false,
    status: 405,
    json: async () => ({ message: "Method not supported in mock API" }),
  };
};
